import React from "react"

import MasterInfo from "./MasterInfo"
import { Color } from "../../../../../constants/V2/color"

type Props = {
  backgroundColor: Color
  headerText: string
  subscriptText?: string
  bodyText: string
  linkText: string
  linkUrl: string
  linkColor: Color
  size?: "small" | "large"
  mobileGridOrder?: number
}

const TextInfo = (props: Props) => {
  return <MasterInfo buttonStyle="pill" {...props} />
}

export default TextInfo
